export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES'
export const UPDATE_CATAGORY_PAGINATION = 'UPDATE_CATAGORY_PAGINATION'
export const UPDATE_CATEGORY_NAVIGATION = 'UPDATE_CATEGORY_NAVIGATION'
export const UPDATE_MANAGEMENT_CATEGORIES = 'UPDATE_MANAGEMENT_CATEGORIES'
